import { Component } from "react"
import PropTypes from "prop-types"
import { Stepper, Step, StepLabel, Button, StepButton, Paper } from "@mui/material"

class Steps extends Component {
  static propTypes = {
    disableVariables: PropTypes.object.isRequired,
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    goToStep: PropTypes.func,
    goBack: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    subHeaderComponent: PropTypes.object,
  }

  renderStepHeader = (step, i) => {
    const { goToStep, activeStep, goBack } = this.props

    const onClick = () => {
      if (i < activeStep) {
        if (goBack) {
          goBack()
        } else {
          goToStep(i)
        }
      }
    }

    return <Step key={i}>
      <StepButton onClick={onClick}>
        <StepLabel
          classes={{
            iconContainer: "step-icon",
            label: "step",
            active: "step-active",
            disabled: "step-disabled",
          }}
        >
          {step.label}
        </StepLabel>
      </StepButton>
    </Step>
  }

  render() {
    const { activeStep, steps, disableVariables, onSubmit, onCancel, subHeaderComponent } = this.props

    return <div className="stepper-header">
      <Paper square elevation={1}>
        <Stepper activeStep={activeStep} className="stepper" classes={{ root: "stepper-root" }}>
          {steps.map((step, i) => this.renderStepHeader(step, i))}
        </Stepper>
      </Paper>

      <Paper square elevation={1} className="sub-stepper">
        <div className="stepper-sub-header-wrapper">
          {subHeaderComponent}
        </div>
        <div className="stepper-buttons-wrapper">
          <Button
            className="stepper-apply-button"
            variant="contained"
            size="large"
            color="primary"
            disabled={steps[activeStep].submitButton.isDisabled(disableVariables)}
            onClick={onSubmit}
          >
            {steps[activeStep].submitButton.text}
          </Button>
          {steps[activeStep].cancelButton && <Button
            className="stepper-cancel-button"
            variant="contained"
            size="large"
            color="primary"
            onClick={onCancel}
          >
            {steps[activeStep].cancelButton.text}
          </Button>}
        </div>
      </Paper>
    </div>
  }
}

export default Steps
